import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../store/AuthContext";
import { CHECK_RESET_SENHA } from "../../services/meuCorreios";
import useFetch from "../hooks/useFetch";

const ProtectedPasswordResetRoute = ({ children }) => {
  const { user, login } = React.useContext(AuthContext);
  const navigate = useNavigate();
  const { request: requestCheckReset, data: dadosCheckReset } = useFetch();

  useEffect(async () => {
    if (login === false) {
      navigate("/login");
      return;
    }

    if (login === true && user?.sub) {
      await requestCheckReset(CHECK_RESET_SENHA(user.sub));
    }
  }, [login, user, navigate]);

  useEffect(() => {
    if (dadosCheckReset) {
      if (dadosCheckReset.senhaExpirada !== true) {
        navigate("/principal");
        return;
      }
    }
  }, [dadosCheckReset, navigate]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };

    const handlePopState = (e) => {
      e.preventDefault();
      navigate("/redefinir-senha-obrigatoria", { replace: true });
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);

    window.history.replaceState(null, "", "/redefinir-senha-obrigatoria");

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  if (login === true && dadosCheckReset?.senhaExpirada === true) {
    return children;
  }

  return null;
};

export default ProtectedPasswordResetRoute;
